<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";

export default {
  components: {Card},
  mixins: [FormElements, Changes],
  data() {
    return {
      user: {},
      customer: {},
      product: {},

      form: useForm({
        customer_id: '',
        product_id: '',
        user_id: this.$page.props.auth.user.id,
        work_order_id: '',
        inspection_technician_name: '',
        valid_until: '',
        recalibration_month: '',
        last_service_date: ''
      })
    }
  },
  methods: {
    setCustomerProduct(customer_product) {
      this.user = customer_product.user ?? {};
      this.customer = customer_product.customer ?? {};
      this.product = customer_product.product ?? {};

      this.form.defaults({
        user_id: customer_product.user_id,
        customer_id: customer_product.customer_id,
        product_id: customer_product.product_id,
        work_order_id: customer_product.work_order_id,
        inspection_technician_name: customer_product.inspection_technician_name,
        valid_until: customer_product.valid_until,
        recalibration_month: customer_product.recalibration_month,
        last_service_date: customer_product.last_service_date,
      });
      this.form.reset();
      this.form.isDirty = false;
    },
  }
}
</script>

<template>
  <div class="row g-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Product Koppeling</h2>

        <Select
            v-model="form.product_id"
            name="product_id"
            label="Serienummer"
            :form="form"
            :ajaxUrl="route('api.v1.products.list')"
            :currentValueLabel="product.serial_number"
        />

        <Input
            :form="form"
            v-model="form.valid_until"
            name="valid_until"
            :required="true"
            type="date"
            label="Geldig tot"
        />

        <Select
            v-if="$page.props.auth.permissions.includes('manage all customer_products')"
            v-model="form.user_id"
            name="user_id"
            label="Werknemer"
            :form="form"
            placeholder="Werknemer"
            :ajaxUrl="route('api.v1.users.list')"
            :currentValueLabel="user.name"
        />

      </Card>
    </div>
  </div>

</template>